<template>
  <login-wrapper
    v-if="branding"
    :branding="branding"
    :title="$t('registration')"
    :loading="loading"
  >
    <registration-form
      class="mt-2"
      :sending="sending"
      :token-error="tokenError"
      :registration-data="registrationData"
      @finish-registration="finishRegistration"
    />
  </login-wrapper>
</template>

<script setup lang="ts">
import { useTitle } from '@/helpers'
import LoginWrapper from '@/modules/authentication/components/LoginWrapper.vue'
import RegistrationForm from '@/modules/authentication/components/RegistrationForm.vue'
import useRegistration from '@/modules/authentication/useRegistration'
import useBranding from '@/modules/portalSettings/useBranding'
import { useStateManager } from '@/store'
import { InvitationRegistration } from '@/types/index'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { t } = useI18n()
useTitle(ref(t('windowTitle.Registration')))
useStateManager().reset()
const token = useRoute().params.token as string
useRegistration().checkRegisterToken({ value: token })

const { branding } = useBranding()
const { tokenError, sending, loading, registrationData } = storeToRefs(useRegistration())

const finishRegistration = (dto: InvitationRegistration) => {
  dto.token.value = token
  useRegistration().finishRegistration(dto)
}
</script>
